
import React from 'react';
import { connect } from 'react-redux';
import { getTransactions } from '../actions/actions'
import 'antd/dist/antd.css';
import { Table, Button, Dropdown, Icon, Menu } from 'antd';
import { Resizable } from 'react-resizable';
import PaginationComponent from './PaginationComponent';


const ResizeableTitle = props => {
    const { onResize, width, ...restProps } = props;

    if (!width) {
        return <th {...restProps} />;
    }

    return (
        <Resizable width={width} height={0} onResize={onResize}>
            <th {...restProps} />
        </Resizable>
    );
};

const menu = (
    <Menu >
        <Menu.Item key="1">Reverse</Menu.Item>
        <Menu.Item key="3">Repush</Menu.Item>
    </Menu>
);

class TransactionTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            columns: [
                {
                    title: 'Date',
                    dataIndex: 'date',
                    width: 150,
                },
                {
                    title: 'Customer Email',
                    dataIndex: 'email',
                    width: 300,
                },
                {
                    title: 'Transaction Ref',
                    dataIndex: 'transactionRef',
                    width: 180,
                },
                {
                    title: 'Transaction Type',
                    dataIndex: 'transactionType',
                    width: 150,
                },
                {
                    title: 'Amount',
                    dataIndex: 'amount',
                    width: 100,
                },
                {
                    title: 'QT Response Code',
                    dataIndex: 'qtResponseCode',
                    width: 100,
                },
                {
                    title: 'Webpay Response Code',
                    dataIndex: 'webpayResponseCode',
                    width: 100,
                },
                {
                    title: 'Transaction Response',
                    dataIndex: 'transactionResponse',
                    width: 200,
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                    width: 180,
                },
                {
                    title: 'Action',
                    key: 'action',
                    render: () => <section>
                        <Dropdown overlay={menu} disabled>
                            <Button>
                                Actions <Icon type="down" />
                            </Button>
                        </Dropdown>
                    </section>
                },
            ],
            data: [],
            pageSize: 20,
            pageNo: 1,
            total: 500
        };

        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.onPaginationChange = this.onPaginationChange.bind(this);
    }


    componentDidMount() {
        const payload = {
            transactionReference: '',
            status: '',
            startDate: '',
            endDate: '',
            customerEmail: '',
            pageNo: 1,
            pageSize: 20
        }
        this.props.getTransactions(payload);
    }

    componentDidUpdate(prevProps) {
        const { transactions } = this.props;

        if (transactions !== prevProps.transactions) {
            this.setState({
                data: transactions,
            });
        }
    }


    components = {
        header: {
            cell: ResizeableTitle,
        },
    };

    handleResize = index => (e, { size }) => {
        this.setState(({ columns }) => {
            const nextColumns = [...columns];
            nextColumns[index] = {
                ...nextColumns[index],
                width: size.width,
            };
            return { columns: nextColumns };
        });
    };

    handlePageSizeChange(value) {
        if (value > this.props.paginationData.pageCount) {
            const newPayload = { ...this.props.searchParam };
            newPayload.pageSize = Number(value);
            newPayload.pageNo = this.props.pageCount;
            this.setState({
                pageSize: newPayload.pageSize,
                pageNo: newPayload.pageNo
            });
            this.props.getTransactions(newPayload);
        } else {
            const newPayload = { ...this.props.searchParam };
            newPayload.pageSize = Number(value);
            this.setState({
                pageSize: newPayload.pageSize
            });
            this.props.getTransactions(newPayload);
        }
    }

    onPaginationChange(value) {
        const newPayload = { ...this.props.searchParam };
        newPayload.pageNo = Number(value);
        this.setState({
            pageNo: newPayload.pageNo
        });
        this.props.getTransactions(newPayload);
    }


    render() {
        const { loading, paginationData } = this.props;
        const columns = this.state.columns.map((col, index) => ({
            ...col,
            onHeaderCell: column => ({
                width: column.width,
                onResize: this.handleResize(index),
            }),
        }));

        return <section>
            <PaginationComponent onPaginationChange={(item) => this.onPaginationChange(item)} handlePageSizeChange={this.handlePageSizeChange} loading={loading} pageSize={paginationData.pageSize} total={paginationData.dataSize} showPageSize={true} />
            <Table bordered components={this.components} columns={columns} dataSource={this.state.data} loading={loading} pagination={false} />
            <PaginationComponent onPaginationChange={(item) => this.onPaginationChange(item)} handlePageSizeChange={this.handlePageSizeChange} loading={loading} pageSize={paginationData.pageSize} total={paginationData.dataSize} showPageSize={false} />
        </section>
    }
}

const mapStateToProps = (state) => {
    return {
        transactions: state.transactions,
        loading: state.loading,
        searchParam: state.searchParam,
        paginationData: state.paginationData
    }
}

export default connect(mapStateToProps, { getTransactions })(TransactionTable);